export function getBrandText(key, brandId, lang, translations) {
  if (!translations || !key) return key;
  
  try {
    const translationKey = `${brandId}_${lang}_${key}`;
    return translations[translationKey] || key;
  } catch (error) {
    return key;
  }
}

export * from '../brand/brand.config.js';